import { memo, useCallback } from 'react';
import { View } from 'react-native';
import ActionButton from './display/actionbutton';
import * as ASSETS from '../../constants/assets';
import { THEME, COLOR } from '../../constants/styles';

export default memo(function ActionButtons(props) {
  const handleInfoPress = useCallback(() => {
    props.onInfoPress(props.item);
  }, [props.item, props.onInfoPress]);
  const handlePreviewPress = useCallback(() => {
    props.onPreviewPress(props.item);
  }, [props.item, props.onPreviewPress]);
  const handleCancelPress = useCallback(() => {
    props.onCancelPress(props.item);
  }, [props.item, props.onCancelPress]);
  const handleContactPress = useCallback(() => {
    props.onContactPress(props.item);
  }, [props.item, props.onContactPress]);
  const handleRejectPress = useCallback(() => {
    props.onRejectPress(props.item);
  }, [props.item, props.onRejectPress]);
  const handleAcceptPress = useCallback(() => {
    props.onAcceptPress(props.item);
  }, [props.item, props.onAcceptPress]);
  const handleEditPress = useCallback(() => {
    props.onEditPress(props.item);
  }, [props.item, props.onEditPress]);

  return (
    <View style={[THEME.basicRow]}>
      {!!props.onContactPress && (
        <ActionButton
          source={ASSETS.message}
          disabled={props.contactDisabled}
          onPress={handleContactPress}
          extraStyle={{ width: 21, height: 21, top: 1.5 }}
        />
      )}
      {!!props.onInfoPress && (
        <ActionButton
          source={ASSETS.info}
          disabled={props.infoDisabled}
          onPress={handleInfoPress}
        />
      )}
      {!!props.onEditPress && (
        <ActionButton
          source={ASSETS.edit}
          disabled={props.editDisabled}
          onPress={handleEditPress}
          extraStyle={{ width: 17, height: 17 }}
        />
      )}
      {!!props.onPreviewPress && (
        <ActionButton
          source={ASSETS.preview}
          disabled={props.previewDisabled}
          onPress={handlePreviewPress}
          extraStyle={{ tintColor: COLOR.callToAction, width: 23, height: 23 }}
        />
      )}
      {!!props.onCancelPress && (
        <ActionButton
          source={ASSETS.reject}
          disabled={props.cancelDisabled}
          onPress={handleCancelPress}
        />
      )}
      {!!props.onRejectPress && (
        <ActionButton
          source={ASSETS.reject}
          disabled={props.rejectDisabled}
          onPress={handleRejectPress}
          testID={props.rejectButtonTestId}
        />
      )}
      {!!props.onAcceptPress && (
        <ActionButton
          source={ASSETS.approve}
          disabled={props.acceptDisabled}
          onPress={handleAcceptPress}
          testID={props.acceptButtonTestId}
        />
      )}
    </View>
  );
});
